var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7722 2.68888C11.4493 2.16225 12.3804 2.12934 13.0892 2.59013L13.2279 2.68888L21.6117 9.20958C22.3334 9.77096 21.9818 10.9014 21.1133 10.9946L20.9971 11.0007H20.0001V19.0007C20.0001 20.0551 19.1842 20.9189 18.1494 20.9953L18.0001 21.0007H6.00005C4.94569 21.0007 4.08189 20.1849 4.00554 19.15L4.00005 19.0007V11.0007H3.00297C2.0896 11.0007 1.67147 9.89315 2.30039 9.28582L2.38841 9.20958L10.7722 2.68888ZM12.0001 4.26759L5.62546 9.2256C5.85399 9.41078 6.00005 9.69371 6.00005 10.0107V19.0007H9.00005V14.0007C9.00005 12.3438 10.3432 11.0007 12.0001 11.0007C13.6569 11.0007 15.0001 12.3438 15.0001 14.0007V19.0007H18.0001V10.0107C18.0001 9.69369 18.1461 9.41077 18.3746 9.2256L12.0001 4.26759ZM12.0001 13.0007C11.4478 13.0007 11.0001 13.4484 11.0001 14.0007V19.0007H13.0001V14.0007C13.0001 13.4484 12.5523 13.0007 12.0001 13.0007Z",
    fill: "#967842"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a8c0ee69ba3344b11aca566d96d886eb.svg";
export { ForwardRef as ReactComponent };